import React from 'react'
import { Link } from 'gatsby'
import slugify from 'slugify'
import { BLOCKS, INLINES } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import VideoPlayer from '~/components/slices/videoPlayer'
import Table from '~/components/slices/table'
import Testimony from '~/components/slices/testimony'
import CookiesSettings from '~/components/core/cookiesSettings'
import trads from '~/intl/trads.json'
export const WysiwygGql = (props) => {
  const {
    document,
    isProject,
    hasTitle,
    lang,
    references,
    isFr,
    newsroomUrls,
  } = props

  const getReference = (references, node) => {
    const foundReference = references?.find(
      (reference) => reference.contentful_id === node.data.target.sys.id,
    )

    return foundReference
  }

  const renderTitle3 = (node) => {
    let title = <h3>{node.content[0].value}</h3>
    if (!hasTitle) {
      title = <h2>{node.content[0].value}</h2>
    }

    return title
  }

  const getCustomPath = (path, isFr) => {
    if (path === 'labo') {
      return isFr ? 'labo' : 'lab'
    }
    if (path === 'project') {
      return isFr ? 'projet' : 'project'
    } else return path
  }

  const renderFrontImg = ({ file, altImage, lang }) => (
    <img
      className="lazyload block mx-auto"
      src={file.file.url}
      alt={altImage ? altImage[lang] : ''}
    />
  )

  const renderVideo = ({ reference, hasTitle }) => {
    return (
      <VideoPlayer data={reference} isWysiwyg={true} sliceHasTitle={hasTitle} />
    )
  }

  const renderTestimony = ({ reference, isProject, isInText = false }) => {
    return isProject ? <Testimony data={reference} isProject={true} isInText={isInText} /> : null;
  }


  const renderTable = (node) => <Table datas={node} />

  const renderAssetHyperlink = (node, lang) => {
    const reference = getReference(references, node)

    const text = node.content[0].value
    const file = reference?.file
    const url = file?.[lang]?.url || file?.url
    return (
      <a href={url} target="_blank" rel="noopener noreferrer">
        {text}
      </a>
    )
  }

  const renderEntryHyperlinkFromGql = (node, lang, newsroomUrls) => {
    const langPrefix = lang === 'fr' ? '' : 'en/'
    const itemData = node.content
    const itemTypeField = node.type
    const itemMetaData = node.data.target?.sys

    const reference = getReference(references, node)

    const text = itemData[0].value
    const isExternalLink =
      itemMetaData.contentType === 'ContentfulSimulator' ||
      itemMetaData.contentType === 'ContentfulContact'

    if (!itemData) {
      return null
    }
    if (!reference) {
      return <span>{text}</span>
    }

    let path = (
      itemMetaData.linkType === 'Entry'
        ? reference?.__typename
        : itemMetaData.linkType
    )
      .replace('Contentful', '')
      .toLowerCase()

    const customPath = getCustomPath(path, isFr)

    const newsroomCorrespondanceFirstStep =
      trads['fr'].lab.titleContentTypes[path]
    const newsroomCorrespondance =
      newsroomCorrespondanceFirstStep === 'Pages'
        ? reference.customType
        : newsroomCorrespondanceFirstStep

    const newsroomPrefix =
      newsroomUrls[newsroomCorrespondance] &&
      newsroomUrls[newsroomCorrespondance][lang]

    const titleField = reference.title?.[lang] || reference.title
    const slugField = reference.slug?.[lang] || reference.slug
    const slug = slugify(slugField || titleField, {
      lower: true,
      remove: /[*+~.()'"!?:@,]/g,
    })

    const newsRoomUrl = `/${newsroomPrefix}/${slug}`
    const notNewsRoomUrl =
      customPath === 'page' || customPath === 'hub' || customPath === 'contact'
        ? `/${langPrefix}${slug}`
        : `/${langPrefix}${customPath}/${slug}`
    const url = `${!!newsroomPrefix ? newsRoomUrl : notNewsRoomUrl}`

    console.log('aled', customPath, path, url)

    return isExternalLink ? (
      <a href={url}>{text}</a>
    ) : (
      <Link to={url}>{text}</Link>
    )
  }

  const renderText = (text) => {
    return text
      .split('\n')
      .flatMap((text, i) => [i > 0 && <br key={i} />, text])
  }

  const renderEmbeddedEntry = (node, lang, isProject, hasTitle) => {
    const reference = getReference(references, node)

    if (!reference) {
      return null
    }

    switch (reference.__typename) {
      case 'ContentfulFrontImg':
        return renderFrontImg({
          ...reference,
          lang,
        })
      case 'ContentfulVideo':
        return renderVideo({ reference, hasTitle })
      case 'ContentfulTestimony':
        return renderTestimony({ reference, isProject: true, isInText: true })
      case 'ContentfulStyledText':
        return reference.type === 'Indice' ? (
          <sub>{reference.text}</sub>
        ) : (
          <sup>{reference.text}</sup>
        )

      default:
        return 'error'
    }
  }

  const renderHyperLink = (node) => {
    const url = node.data.uri
    const text = node.content[0].value
    const re = new RegExp('^(http|https)://', 'i')
    const mail = new RegExp('^mailto:', 'i')
    if (!url) {
      return <span>{text}</span>
    } else if (url.match(re)) {
      return (
        <a href={url} target="_blank" rel="noopener noreferrer">
          {text}
        </a>
      )
    } else if (url.match(mail)) {
      return <a href={url}>{text}</a>
    } else if (url === 'cookies') {
      return <CookiesSettings text={text} className="show-cookies-settings" />
    } else {
      return <Link to={url}>{text}</Link>
    }
  }

  const optionsForDataFromGraphQL = {
    renderNode: {
      [BLOCKS.EMBEDDED_ENTRY]: (node) =>
        renderEmbeddedEntry(node, lang, isProject, hasTitle),
      'embedded-entry-inline': (node) =>
        renderEmbeddedEntry(node, lang, isProject, hasTitle),
      [BLOCKS.TABLE]: (node) => renderTable(node),
      [INLINES.ASSET_HYPERLINK]: (node) => renderAssetHyperlink(node, lang),
      [INLINES.ENTRY_HYPERLINK]: (node) =>
        renderEntryHyperlinkFromGql(node, lang, newsroomUrls),
      [INLINES.HYPERLINK]: (node) => renderHyperLink(node),
      [BLOCKS.HEADING_3]: (node) => renderTitle3(node),
    },
    renderText: (text) => renderText(text),
  }

  return documentToReactComponents(
    JSON.parse(document.raw),
    optionsForDataFromGraphQL,
  )
}
